<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('lbl.preferences.user')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm"><span>{{$t('tlt.administration')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm/userPreferences"><span>{{$t('lbl.preferences.user')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                     <button class="btn btn-primary" type="button" @click="validateForm"><i class="fa fa-fw fa-lg fa-save"></i><span class=text>Save</span></button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <form>
                <div class="row">
                 <div class="col-md-4">   
                <div class="card col-md-12 left_margin">
                    <div class="card-body">                        
                        <div class="form-group col-md-12">
                            <label class="control-label">{{$t('lbl.user.language')}}:</label>
                            <select v-model="language"
                            :class="{'form-control': true, 'is-invalid': errors.has('language') }"
                            name="language">
                                <option v-for="language1 in languages" :key="language1.key" :value="language1.key">{{ $t(language1.description) }}</option>
                            </select>
                            <span v-show="errors.has('language')" class="lbl-obg">
                                {{ errors.first('language') }}
                            </span>
                        </div>
                    </div>
                </div>
                </div>
                <div class="col-md-4">  
                <div class="card col-md-12">
                    <div class="card-body">
                        <div class="form-group col-md-12">
                                <label class="control-label">{{$t('lbl.preferences.user.date.timezone')}}:</label>
                                <select v-model="timezone"
                                :class="{'form-control': true, 'is-invalid': errors.has('group') }"
                                name="timezone">                                    
                                    <option value="S">{{ $t("lbl.preferences.user.date.timezone.show") }}</option>
                                    <option value="D">{{ $t("lbl.preferences.user.date.timezone.dont.show") }}</option>
                                    <option value="I">{{ $t("lbl.preferences.user.date.timezone.show.icon") }}</option>
                                </select>
                                <span v-show="errors.has('timezone')" class="lbl-obg">
                                    {{ errors.first('timezone') }}
                                </span>
                            </div>
                            <div class="form-group col-md-12">
                                <label class="control-label">{{$t('lbl.preferences.user.date.format')}}:</label>
                                <select v-model="dateFormat"
                                 :class="{'form-control': true, 'is-invalid': errors.has('dateFormat') }"
                                 name="dateFormat">
                                    <option value="M">{{ $t("lbl.preferences.user.date.format.month.day") }}</option>                                    
                                    <option value="D">{{ $t("lbl.preferences.user.date.format.day.month") }}</option>
                                </select>
                                <span v-show="errors.has('dateFormat')" class="lbl-obg">
                                    {{ errors.first('dateFormat') }}
                                </span>
                            </div>
                            <div class="form-group col-md-12">
                                <label class="control-label">{{$t("lbl.preferences.user.final.date.format")}}:</label>
                                <div class="row">
                                   <h4> {{ finalDateFormater }}</h4><span v-if="showDaylightSaveIcon"><i class="fa fa-fw fa-lg fa-sun"></i></span>

                                </div>
                            </div> 
                        
                    </div>
                    </div>
                </div>
                </div>
            </form>
        </section>
    </div>
 </template>
<style>
.CodeMirror {
  border: 1px solid #eee;
  /* todo change to responsible */
  height: 340px; 
}
.left_margin{
    margin-right: 8px;
}
</style>

<script>

import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/xml/xml.js'
import 'codemirror/mode/yaml/yaml.js'
import 'codemirror/mode/properties/properties.js'
//import 'codemirror/theme/base16-dark.css'
import 'codemirror/theme/eclipse.css'
import { createHelpers } from 'vuex-map-fields';
import { fields } from '@/model/adm/UserPreferences'
import { debug } from 'util';
import  { TIMEZONE, DATEFORMAT }  from '@/model/constants'

const { mapFields } = createHelpers({
    getterType: 'userPreferences/getField',
    mutationType: 'userPreferences/updateField',
  });

export default {
  data () {
    return {
      baseUrl : process.env.VUE_APP_ADM_API_URL,
      showDaylightSaveIcon: false,
      languages: []
    }
  },
  computed: {
     ...mapFields(fields),
      languageValue: {
            get () {
                return this.$store.state.userPreferences.language;
            }
        },
        timezoneValue: {
            get () {
                return this.$store.state.userPreferences.timezone;
            }
        },
        dateFormatValue: {
            get () {
                return this.$store.state.userPreferences.dateFormat;
            }
        },
    finalDateFormater: function(){ 
        var timezone ='';
        this.showDaylightSaveIcon = false;
        switch(this.timezoneValue)
        {   case TIMEZONE.DontShow:
               timezone = ""
            break;
            case TIMEZONE.DST:
               this.showDaylightSaveIcon = true
            break;
            case TIMEZONE.Show:
               timezone = "-0300"
            break;
        }
        var datetime=''
        switch(this.dateFormatValue)
        {   case DATEFORMAT.DayMonth:
               datetime = "31/01/2019 15:00:00"
            break;
            case DATEFORMAT.MonthDay:
               datetime = "01/31/2019 15:00:00"
            break;
        }
        return  datetime+" "+timezone;
    }
  },
  methods: {
    getUserPrefSession(){
            
    },
    validateForm () {
                var up = this.$store.state.userPreferences
                this.$store.dispatch('api/put', {url: this.baseUrl+'adm-service/adm/user/userPreferences/save',entity:up})
                .then(json => {
                    this.$store.dispatch("base/showSuccess", {
                        userAlertSuccessStr:"Update success for user " + json.user.name+".",
                        dismissCountDown: 5,
                        userAlertSuccessVisible: false,
                    }, {root: true})
                    this.$i18n.set(json.language);
                });
    },
  },
  created() {
        var url = this.baseUrl + "adm-service/adm/language/findAll/";
        this.$store.dispatch("api/get", { url })
            .then(json => {
                this.languages=json               
        });

    }
};

</script>